import type { DocumentType, EvidenceDocument, RegulationPack } from '../types';

export type TechnicalFileCategoryId =
  | 'machine_product_overview'
  | 'instructions_for_use'
  | 'risk_assessment'
  | 'declaration'
  | 'drawings_specifications'
  | 'standards_list'
  | 'test_evidence'
  | 'maintenance_service_information'
  | 'other_supporting_evidence'
  | 'lvd_declaration'
  | 'lvd_electrical_protection'
  | 'lvd_technical_documentation';

export interface TechnicalFileCategory {
  id: TechnicalFileCategoryId;
  documentTypes: readonly DocumentType[];
}

export interface CategorizedTechnicalFile extends TechnicalFileCategory {
  documents: EvidenceDocument[];
}

export const TECHNICAL_FILE_CATEGORIES: readonly TechnicalFileCategory[] = [
  {
    id: 'machine_product_overview',
    documentTypes: ['machine_product_overview'],
  },
  { id: 'instructions_for_use', documentTypes: ['instructions_for_use'] },
  { id: 'risk_assessment', documentTypes: ['risk_assessment'] },
  {
    id: 'declaration',
    documentTypes: [
      'declaration_of_conformity',
      'declaration_of_incorporation',
    ],
  },
  {
    id: 'drawings_specifications',
    documentTypes: ['drawings_specifications'],
  },
  { id: 'standards_list', documentTypes: ['standards_list'] },
  { id: 'test_evidence', documentTypes: ['test_evidence'] },
  {
    id: 'maintenance_service_information',
    documentTypes: ['maintenance_service_information'],
  },
  {
    id: 'other_supporting_evidence',
    documentTypes: ['combined_technical_file', 'other'],
  },
] as const;

const LOW_VOLTAGE_CATEGORIES: readonly TechnicalFileCategory[] = [
  { id: 'lvd_declaration', documentTypes: ['declaration_of_conformity'] },
  {
    id: 'lvd_electrical_protection',
    documentTypes: ['test_evidence', 'drawings_specifications'],
  },
  {
    id: 'lvd_technical_documentation',
    documentTypes: ['risk_assessment', 'combined_technical_file'],
  },
];

export function categorizeTechnicalFile(
  documents: EvidenceDocument[],
  regulationPacks: readonly RegulationPack[] = []
): CategorizedTechnicalFile[] {
  const categories = regulationPacks.includes('low_voltage_2014_35_eu')
    ? [...TECHNICAL_FILE_CATEGORIES, ...LOW_VOLTAGE_CATEGORIES]
    : TECHNICAL_FILE_CATEGORIES;
  return categories.map(category => ({
    ...category,
    documents: documents.filter(document =>
      category.documentTypes.includes(document.documentType)
    ),
  }));
}
